
  import { defineComponent, PropType } from 'vue';
  import { mapGetters } from 'vuex';

  import { VED_COMMON_GETTERS_NAME } from '../../store/vedCommon/name';
  import { TRegionAggregatedFilter } from '../../types/region-aggregated';
  import { getBasePeriodsInfo } from '../../utils/base-info/periods';
  import { getBaseTreeInfo } from '../../utils/base-info/tree';
  import BaseInfo from '../common/base-info/BaseInfo.vue';
  import { TBaseInfoItem } from '../common/base-info/types';

  export default defineComponent({
    name: 'RegionAggregatedBaseInfo',
    components: {
      BaseInfo,
    },
    props: {
      filter: {
        type: Object as PropType<TRegionAggregatedFilter>,
        required: true,
      },
      productText: {
        type: String,
      },
    },
    computed: {
      ...mapGetters({
        getCountriesTree: VED_COMMON_GETTERS_NAME.getCountriesTree,
      }),
      getItems(): TBaseInfoItem[] {
        return [this.getPeriodsItem, this.getCountriesItem, this.getProductsItem];
      },
      getPeriodsItem(): TBaseInfoItem {
        return {
          label: 'Период',
          value: getBasePeriodsInfo(this.filter.periods),
          isLoading: false,
        };
      },
      getCountriesItem(): TBaseInfoItem {
        return {
          label: 'Страна',
          value: getBaseTreeInfo(this.getCountriesTree, this.filter.countries),
          isLoading: !this.getCountriesTree.length,
        };
      },
      getProductsItem(): TBaseInfoItem {
        return {
          label: 'Товар',
          value: this.productText ?? '',
          isLoading: this.productText == null,
        };
      },
    },
  });
